import React from 'react'
import { useParams } from 'react-router-dom'
import { useRedirectTo } from '@@partner:helpers/hooks/location'

import { Panel } from 'rsuite'
import PromocodeForm from '@components/marketing/promocode/PromocodeForm'

import { ROUTE_MARKETING_PROMOCODE } from '@@partner:config/routes'

export default function PromocodeFormPage () {
  const { promocodeId, brandSlug } = useParams<any>()
  const redirectToCatalog = useRedirectTo(ROUTE_MARKETING_PROMOCODE, {
    brandSlug
  })

  return (
    <div className="PromocodeFormPage">
      <h1 className="u-heading">
        {promocodeId ? 'Редактирование' : 'Добавление'}
      </h1>
      <Panel shaded>
        <PromocodeForm promocodeId={promocodeId} onSaved={redirectToCatalog} />
      </Panel>
    </div>
  )
}
